import React from "react";
import styled from "styled-components";
import Button from '@material-ui/core/Button';

export const PageWrapper = styled.div`
  @media not print {
    display: flex;
    align-items: stretch;
    height: 100%;
    width: 100%;
    position: absolute;
    flex-direction: column;
  }

  @media print {
    overflow: visible;
    height: auto;
    position: relative;
  }

  .page-number {
    font-family: "Open Sans Condensed" !important;
  }
`;

export const PageContent = styled.div`
  flex-grow: 1;
  position: relative;
  background: #f3f3f3;

  @media print {
    background: #fff;
    overflow: visible;
  }
`;

export const SidebarWrapper = styled.div`
  @media not print {
    display: flex;
    align-items: stretch;
    height: 100%;
    width: 100%;
    overflow-x: hidden;
    position: absolute;
  }

  @media print {
    position: static;
  }

  @media not print {
    .fill {
      height: 100%;
      width: 0.01%;
      flex-grow: 1;
      position: relative;
      overflow: auto;
    }
  }

  #divToPrint {
    padding-top: 25px;

    @media print {
      padding-top: 0;
    }
  }
`;

export const DimmerStyle = styled.div`
  &.ui.dimmer {
    position: fixed !important;
    top: 61px !important;
    height: calc(100% - 61px);

    visibility: visible;
    opacity: 1;
    transition: visibility 0.01s 0.1s, opacity 0.01s 0.1s linear;

    &.hide {
      visibility: hidden !important;
      opacity: 0;
      transition: visibility 0.2s 0.5s, opacity 0.2s 0.5s linear;
    }

    .bar {
      transition: width 0.5s ease, background-color 0.5s ease;
    }
  }
`;

export const Footer = styled.div`
  position: absolute;
  bottom: ${(props) => {
    if (props.show) {
      if (props.expand) {
        return "0px";
      } else {
        return "-145px";
      }
    } else {
      return "-185px";
    }
  }};
  width: 100%;
  height: 185px;
  background: #04435e;
  display: flex;
  z-index: 100;
  transition: all 85ms ease-in;
`;

export const FooterLeft = styled.div`
  flex: 1;
`;

export const FooterCenter = styled.div`
  width: 828px;
  display: flex;
`;

export const FooterRight = styled.div`
  flex: 1;
  text-align: right;
`;

export const MessageContainer = styled.div`
  flex: 1;
  font-family: Roboto;
  color: #ffffff;
`;

export const MessageTitle = styled.div`
  font-size: 21px;
  font-weight: bold;
  margin-top: 40px;
`;

export const MessageContent = styled.div`
  font-size: 16px;
  margin-top: 12px;
  opacity: 0.7;
`;

export const ActionArea = styled.div`
  display: flex;
  align-items: center;
  width: 195px;
  margin-left: 40px;
`;

export const ExpandButton = styled((props) => <Button {...props}/>)`
  &&& {
    margin: 4px;
    color: #ffffff;
  }
`;


// WEBPACK FOOTER //
// ./src/pages/MagnetReport/style.js